export default {"src":"/_next/static/media/right_arrow_icon.8704c677.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};